import React from 'react'
import './style.scss'

export default function NotificationButton({ count = 0, children }) {
  if (!count) return children

  return (
    <div className="fb-btn-wrapper">
      {children}
      <span className="fb-badge">{count > 99 ? '99+' : count}</span>
    </div>
  )
}
